import React from "react"
import { Box, Typography } from "@mui/material"
import ClockPopupIcon from "./assets/clockPopupIcon.svg"
import type { StationFeature } from "types/stations"

interface PopupProps {
    chosenStation: StationFeature
}

const PopupOpen: React.FC<PopupProps> = ({ chosenStation }) => {
    return (
        <Box>
            <style>
                {`  .mapboxgl-popup-tip { display: none;}
                .mapboxgl-popup-content {
                width: 230px;
                height: 160px;
                padding: 20px;
                border-radius: 10px;
                border: 1px solid #000;
                }`}
            </style>

            <Typography
                variant="body1"
                sx={{
                    mb: "10px",
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    textAlign: "left",
                }}
            >
                {chosenStation.properties.name}
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "16px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "grey.600",
                }}
            >
                {chosenStation.properties.address}
            </Typography>

            <Box
                sx={{
                    marginTop: "16px",
                    marginBottom: "8px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "4px",
                }}
            >
                <img src={ClockPopupIcon} alt="clock" />
                <Typography
                    variant="body1"
                    sx={{
                        fontFamily: "Roboto",
                        fontSize: "12px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        letterSpacing: "0em",
                        textAlign: "left",
                        color: "#161616",
                    }}
                >
                    Statut
                </Typography>
            </Box>
            <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "16px",
                    letterSpacing: "0em",
                    textAlign: "left",
                    color: "#697077",
                }}
            >
                {chosenStation.properties.status === "available"
                    ? "Disponible"
                    : "Indisponible"}
            </Typography>
        </Box>
    )
}

export default PopupOpen
